import React from "react";
import { Link } from "react-router-dom";
import { gradeClassFor } from "../utils/honeyGrade";
import { localizedName } from "../utils/localizeProduct";
import { useLanguage } from "../i18n/LanguageContext";

const DELIVERY_FEE = 4.99;

function CartPage({ cartItems, onUpdateQuantity, onRemoveItem }) {
  const { language, t } = useLanguage();
  const subtotal = cartItems.reduce(
    (sum, item) => sum + item.price * item.quantity,
    0
  );
  const total = cartItems.length > 0 ? subtotal + DELIVERY_FEE : 0;

  if (cartItems.length === 0) {
    return (
      <div className="cart-wrapper">
        <h2>{t("cart.title")}</h2>
        <p>{t("cart.empty")}</p>
        <Link to="/products" className="btn">
          {t("cart.shopHoney")}
        </Link>
      </div>
    );
  }

  return (
    <div className="cart-wrapper">
      <h2>{t("cart.title")}</h2>

      {cartItems.map((item) => (
        <div className="cart-item" key={item.id}>
          {item.imageUrl ? (
            <img src={item.imageUrl} alt={localizedName(item, language)} />
          ) : (
            <div className="jar-swatch sm">
              <div className="jar-lid" />
              <div className="jar-neck" />
              <div className={`jar-body ${gradeClassFor(item)}`} />
            </div>
          )}
          <div style={{ flex: 1 }}>
            <h3 style={{ margin: 0, fontSize: "1rem" }}>{localizedName(item, language)}</h3>
            <p className="price" style={{ margin: "0.25rem 0" }}>
              ${item.price.toFixed(2)}
            </p>
          </div>
          <input
            type="number"
            min="1"
            value={item.quantity}
            onChange={(e) =>
              onUpdateQuantity(item.id, Number(e.target.value))
            }
          />
          <button
            className="btn-secondary"
            onClick={() => onRemoveItem(item.id)}
          >
            {t("cart.remove")}
          </button>
        </div>
      ))}

      <div className="cart-footer">
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <span>{t("cart.subtotal")}</span>
          <span>${subtotal.toFixed(2)}</span>
        </div>
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <span>{t("cart.delivery")}</span>
          <span>${DELIVERY_FEE.toFixed(2)}</span>
        </div>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            fontWeight: 700,
            marginTop: "0.5rem",
            paddingTop: "0.5rem",
            borderTop: "1px solid var(--line)",
          }}
        >
          <span>{t("cart.total")}</span>
          <span>${total.toFixed(2)}</span>
        </div>

        <Link
          to="/checkout"
          className="btn"
          style={{ marginTop: "1rem", display: "inline-block" }}
        >
          {t("cart.proceed")}
        </Link>
      </div>
    </div>
  );
}

export default CartPage;
